module.exports = __webpack_public_path__ + "static/media/babyw.257334da.png";